import { Place } from "@dto/Place";
import { api } from "./api";
import { convertToCamel } from "@lib/convertToCamel";
import { ListEntitiesRequest } from "@store/apiTypes";

export const placeApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getPlace: build.query<Place, string | number>({
      query: (idOrSlug) => {
        return { url: `/places/${idOrSlug}` };
      },
      transformResponse: (responseData) => {
        const place = convertToCamel(responseData) as Place;
        return place;
      },
      providesTags: (_place, _err, id) => [{ type: "Place", id }],
    }),
    listPlaces: build.query<Place[], ListEntitiesRequest>({
      query: (request) => {
        const queryParams = [`page=${request.page}`];

        if (request.categoryIds && request.categoryIds.length > 0) {
          request.categoryIds.forEach((id) => {
            queryParams.push(`category_ids[]=${encodeURIComponent(id)}`);
          });
        }

        if (request.exclusiveCategoryIds.length > 0) {
          request.exclusiveCategoryIds.forEach((id) => {
            queryParams.push(
              `exclusive_category_ids[]=${encodeURIComponent(id)}`,
            );
          });
        }

        if (request.bbox && request.geographicPaginationEnabled) {
          queryParams.push("south_west_latitude=" + request.bbox[1]);
          queryParams.push("south_west_longitude=" + request.bbox[0]);
          queryParams.push("north_east_latitude=" + request.bbox[3]);
          queryParams.push("north_east_longitude=" + request.bbox[2]);
        }

        const url = `/places?${queryParams.join("&")}`;

        return { url: url };
      },
      transformResponse: (responseData) => {
        const places = convertToCamel(responseData) as any;
        places.forEach((place) => {
          place.type = "Place";
        });
        return places as Place[];
      },
    }),
  }),
});

export const { useGetPlaceQuery, useListPlacesQuery } = placeApi;

export const {
  endpoints: { getPlace, listPlaces },
} = placeApi;
